import { useDrilldownSchema } from 'features/drilldown/rolodex/DrilldownDataSchema'
import {
  convertKeyToLabel,
  DrilldownRolodexType,
} from 'features/drilldown/rolodex/ontology/ontologyTypes'
import _ from 'lodash'
import { Dispatch, FC, ReactNode, SetStateAction, useMemo } from 'react'
import styled from 'styled-components'

import { OneStepSelect, OneStepSelectOption } from './components/OneStepSelect'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  gap: 1rem;
`

type TypeSelectProps = {
  label?: ReactNode
  types?: ReadonlyArray<DrilldownRolodexType>
  selectedType: DrilldownRolodexType
  setSelectedType: Dispatch<SetStateAction<DrilldownRolodexType>>
  placeholder?: string
  width?: string
}

export const DrilldownTypeSelect: FC<TypeSelectProps> = ({
  label,
  selectedType,
  setSelectedType,
  types: propTypes,
  placeholder,
  width = '240px',
}) => {
  const { fields: hookFields, entryTypeNames } = useDrilldownSchema()
  const types = useMemo(
    () =>
      propTypes ??
      _.uniq(Object.values(hookFields).map((field) => field.entryType)),
    [hookFields, propTypes]
  )

  const typeOptions = useMemo<ReadonlyArray<OneStepSelectOption>>(
    () =>
      types
        .map((entryType) => ({
          value: entryType,
          label: entryTypeNames[entryType] ?? convertKeyToLabel(entryType),
        }))
        .toSorted(),
    [types, entryTypeNames]
  )

  return (
    <Container>
      {label ?? <></>}
      <OneStepSelect
        options={typeOptions}
        selectedValue={selectedType}
        setSelectedValue={setSelectedType}
        placeholder={placeholder}
        width={width}
      />
    </Container>
  )
}
